/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Celebrate from 'DesignSystem/Celebrate/react'
import MedicalForm from './MedicalForm/index'
import No from './No/index'
import React from 'react'
import TitleLarge from 'DesignSystem/TitleLarge/index'
import Treatment from './Treatment/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Auth/SignUp/Instructions/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let flowShortcutsSourceValueData = fromData.useDataValue({ viewPath,
context: 'flow_shortcuts',
path: 'source',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: flowShortcutsSourceValueData,
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsGreen400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.400'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<Celebrate
  viewPath={`${viewPath}/Celebrate`}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bc-2-Z1Yf8zk': dtColorsGreen400,'--pb-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-5-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-6-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MedicalForm'}>
<MedicalForm
  viewPath={`${viewPath}/MedicalForm`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Treatment'}>
<Treatment
  viewPath={`${viewPath}/Treatment`}
/>
</fromFlow.When>
</div>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
/>
<TitleLarge
  viewPath={`${viewPath}/TitleLarge`}
 text="Sign Up"
 color={dtColorsNeutral700}
/>
{children}
</React.Fragment>)
}